import { Box, Button, Drawer, TextField } from "@mui/material";
import React, { useState, SyntheticEvent } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import { BASE_URL } from "../services/client/rest";
import CircularProgress from "@mui/material/CircularProgress";
import MySnackbarContentWrapper from "../MySnackbarContentWrapper";

function IdealSupportUtilities({
  open,
  onClose,
  serialNumber,
}: {
  open: boolean;
  onClose: any;
  serialNumber: any;
}) {
  const [openDrawer, SetOpenDrawer] = React.useState<any>(open);
  const [currentRow, SetCurrentRow] = useState([] as any);
  const [output, SetOutput] = useState("" as string);
  const [result, SetResult] = useState("" as string);
  const [openSnackBar, setOpen] = React.useState(false);
  const [connectorBtnLoader, setconnectorBtnLoader] = React.useState(false);
  const [shutDownBtnLoader, setShutDownBtnLoader] = React.useState(false);

  const handleClose = (event?: SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  var bearer = "Bearer " + localStorage.getItem("token");
  const headers = {
    Authorization: bearer,
  };

  function OnClickRestartConnector() {
    setconnectorBtnLoader(true);

    const request = {
      dbShutdown: currentRow.dbShutdown,
      serialNumber: serialNumber,
      csiPassword: currentRow.csiPassword,
      output: "",
      result: "",
    };
    let url = BASE_URL + "Customer/RestartConnector";

    axios
      .put(url, request, {
        headers,
      })
      .then((response) => {
        SetOutput(response.data.output);
        SetResult(response.data.result);
        setconnectorBtnLoader(false);
        setOpen(true);
      })
      .catch((err) => {
        SetResult(err.response.data);
        setconnectorBtnLoader(false);
        setOpen(true);
      });
  }
  function OnClickDbSutdown() {
    setShutDownBtnLoader(true);

    const request = {
      dbShutdown: currentRow.dbShutdown,
      serialNumber: serialNumber,
      csiPassword: currentRow.csiPassword,
      output: "",
      result: "",
    };
    let url = BASE_URL + "Customer/DbShutdown";

    axios
      .put(url, request, {
        headers,
      })
      .then((response) => {
        SetOutput(response.data.output);
        SetResult(response.data.result);
        setShutDownBtnLoader(false);
        setOpen(true);
      })
      .catch((err) => {
        SetResult(err.response.data);
        setShutDownBtnLoader(false);
        setOpen(true);
      });
  }
  React.useEffect(() => {
    SetOpenDrawer(open);
  }, [open]);

  function SetValue(key: string, value: any) {
    currentRow[key] = value;
  }

  return (
    <Box>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        {output === "success" ? (
          <MySnackbarContentWrapper
            onClose={handleClose}
            variant="success"
            message={`Operation Successfull ${result}`}
          />
        ) : (
          <MySnackbarContentWrapper
            onClose={handleClose}
            variant="error"
            message={`Something went wrong ${result}`}
          />
        )}
      </Snackbar>

      <Drawer
        PaperProps={{ style: { width: "auto" } }}
        anchor="right"
        open={openDrawer}
        onClose={() => onClose(0)}
        variant={"temporary"}
      >
        <Box style={{ padding: "5px 10px", marginTop: "15px" }}>
          <Box style={{ width: "100%" }}>
            <Box style={{ marginTop: "10px" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Customer Type
                </InputLabel>
                <Select
                  label="Database for DB Shutdown"
                  onChange={(e: any) => {
                    SetValue("dbShutdown", e.target.value);
                  }}
                >
                  <MenuItem value="ICS100c1">ICS100c1</MenuItem>
                  <MenuItem value="ICS100c2">ICS100c2</MenuItem>
                  <MenuItem value="ICS100c3">ICS100c3</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                required
                label="CSI Password"
                onChange={(e: any) => {
                  SetValue("csiPassword", e.target.value);
                }}
                style={{ width: "300px" }}
                type="password"
              />
            </Box>
          </Box>

          {connectorBtnLoader ? (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ padding: "10px", border: "0px solid red" }}
            >
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={OnClickRestartConnector}
                endIcon={<CircularProgress size={16} color="inherit" />}
                disabled={connectorBtnLoader}
              >
                Restart Connector
              </Button>
            </Box>
          ) : (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ padding: "10px", border: "0px solid red" }}
            >
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={OnClickRestartConnector}
              >
                Restart Connector
              </Button>
            </Box>
          )}

          {shutDownBtnLoader ? (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ padding: "10px", border: "0px solid red" }}
            >
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={OnClickDbSutdown}
                endIcon={<CircularProgress size={16} color="inherit" />}
                disabled={shutDownBtnLoader}
              >
                Fix DB Shutdown
              </Button>
            </Box>
          ) : (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ padding: "10px", border: "0px solid red" }}
            >
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={OnClickDbSutdown}
              >
                Fix DB Shutdown
              </Button>
            </Box>
          )}

          {/* {shutDownBtnLoader ? (
            <Box sx={{ display: "flex" }}>
              <CircularProgress
                style={{ marginLeft: "130px", marginTop: "100px" }}
              />
            </Box>
          ) : null} */}
        </Box>
      </Drawer>
    </Box>
  );
}
export default IdealSupportUtilities;
